import ApiChatV2 from "../../gd/api/chat-new"
import asyncSessionLoader from "../../gd/data/async-session-loader"
import Chat from "../../model2/chat/chat/chat";


export default async function sessionInitChats() {
    return new Promise(async (resolve, reject) => {
        await ApiChatV2.resetChatRooms().promise()
        await asyncSessionLoader(findMissingData())

        gd.session.chatsLoaded = true

        resolve(true)
    })
}

const findMissingData = () => {
    let allProjectIds: ID[] = []
    _.map(gd.session.chats!.models, (chat:Chat)=>{
        if (chat.projectId) {
            allProjectIds.push(chat.projectId)
        }
    })

    return gd.session.findMissing({
        projects: _.uniq(allProjectIds)
    })
};